import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { useAuth } from "../../Context/useAuth";
import Container from 'react-bootstrap/Container';

interface Props {}

const Footer = (props: Props) => {
  const { isLoggedIn, user, logout } = useAuth();
  return (
    <footer className="page-footer font-small blue pt-1 mt-5">
      <div className="footer-copyright text-center py-3">
        © 2025 Copyright: MTB Part Picker
      </div>
    </footer>
  );
}

export default Footer;